import * as R from "ramda";
import {
  clearError,
  startLoading,
  stopLoading,
  saveErrorMsg,
} from "../../helpers/api/meta";
import { errorToBeAdded } from "../error";
import { getMe, logout, login } from "../../helpers/api/api";

export const GET_ME_STARTED = "GET_ME_STARTED";
export const GET_ME_SUCCESS = "GET_ME_SUCCESS";
export const GET_ME_FAILURE = "GET_ME_FAILURE";
export const LOGOUT_STARTED = "LOGOUT_STARTED";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const SIGNIN_STARTED = "SIGNIN_STARTED";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAILURE = "SIGNIN_FAILURE";
export const SIGNIN_ENDED = "SIGNIN_ENDED";

export const getMeStarted = () => ({ type: GET_ME_STARTED });
export const getMeSuccess = (success) => ({ type: GET_ME_SUCCESS, success });
export const getMeFailure = (error) => ({ type: GET_ME_FAILURE, error });
export const logoutStarted = () => ({ type: LOGOUT_STARTED });
export const logoutSuccess = () => ({ type: LOGOUT_SUCCESS });

export const signinStarted = () => ({ type: SIGNIN_STARTED });
export const signinSuccess = (success) => ({ type: SIGNIN_SUCCESS, success });
export const signinFailure = (error) => ({ type: SIGNIN_FAILURE, error });
export const signinEnded = () => ({ type: SIGNIN_ENDED });
const updateState = (state, action) => {
  let res = action.success
    ? R.mergeDeepRight(state, { authorized: true, ...action.success })
    : state;
  return res;
};

const updateError = (state, action) => {
  let res = R.mergeDeepRight(state, { authorized: false, error: action.error });
  return res;
};

const initialState = {
  authorized: false,
  loading: false,
  id: null,
  email: null,
  fullname: null,
  last_login: null,
  date_joined: null,
  role: null,
};

const saveMe = (state, action) => {
  const { id, email, fullname, last_login, date_joined ,role} = action.success;
  return R.mergeDeepRight(state, {
    authorized: true,
    id,
    email,
    fullname,
    last_login,
    date_joined,
    role
  });
};
const messages = {
  id: "getMe",
  failure: "Session expired.",
  signinFailed: "Signin failed",
};

export const callGetMe = () => (dispatch) => {
  dispatch(getMeStarted());
  return getMe()
    .then((success) => {
      dispatch(getMeSuccess(success));
      return success;
    })
    .catch((error) => {
      window.sessionStorage.removeItem("token");
      window.location.href = "/login/error/104";
      dispatch(logoutSuccess());
      throw error;
    });
};

export const signin = (body) => (dispatch) => {
  dispatch(signinStarted());
  return login(body)
    .then((success) => {
      window.sessionStorage.setItem("token", success.token);
      dispatch(signinEnded());
      dispatch(signinSuccess(success));
    })
    .catch((error) => {
      dispatch(signinEnded());
      dispatch(signinFailure(error));
      dispatch(errorToBeAdded(error, 'signinFailure', messages.signinFailed))
      throw error;
    });
};

export const signout = () => (dispatch) => {
  dispatch(logoutStarted());
  return logout().finally(() => {
    window.sessionStorage.removeItem("token");
    dispatch(logoutSuccess());
  });
};

export default function sessionReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ME_STARTED: {
      return startLoading(clearError(state));
    }
    case GET_ME_SUCCESS: {
      return saveMe(stopLoading(state), action);
    }
    case GET_ME_FAILURE: {
      return saveErrorMsg(stopLoading(state), action, messages.failure);
    }
    case LOGOUT_STARTED: {
      return startLoading(clearError(state));
    }
    case LOGOUT_SUCCESS: {
      return initialState;
    }
    case SIGNIN_STARTED: {
      return startLoading(clearError(state));
    }
    case SIGNIN_SUCCESS: {
      return updateState(state, action);
    }
    case SIGNIN_FAILURE: {
      return updateError(state, action);
    }
    case SIGNIN_ENDED: {
      return stopLoading(state);
    }
    default:
      return state;
  }
}
